import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var ACTION = {
  OPEN: 0,
  CLOSE: 1,
  DID_MOUNT: 2,
  WILL_UNMOUNT: 3
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var eventManager = {
  events: new Map(),
  on: function on(e, cb) {
    this.events.has(e) || this.events.set(e, []);
    this.events.get(e).push(cb);
    return this;
  },
  off: function off(e) {
    this.events["delete"](e);
    return this;
  },
  emit: function emit(e) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!this.events.has(e)) {
      return false;
    }

    this.events.get(e)
    /* eslint-disable-next-line */
    .forEach(function (cb) {
      return setTimeout(function () {
        return cb.call.apply(cb, [null].concat(toConsumableArray(args)));
      }, 0);
    });
    return true;
  }
};
var options = {
  animationDuration: 500,
  onOpenClass: 'with-modal'
};

var ModalManager = function (_Component) {
  inherits(ModalManager, _Component);

  function ModalManager() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ModalManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ModalManager.__proto__ || Object.getPrototypeOf(ModalManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modals: null,
      modal: null,
      modalActive: false,
      modalOptions: null,
      onClose: null,
      onOpen: null,
      options: null,
      props: null
    }, _this.showModal = function (_ref2) {
      var type = _ref2.type,
          props = _ref2.props,
          options$$1 = _ref2.options;
      var modal = _this.state.modals[type];

      if (!modal) {
        /* eslint-disable-next-line */
        console.warn('[react-modal-handler] ::: No modal registered as ' + type + '!');
      }

      var mergedOptions = Object.assign({}, _this.state.options, options$$1);

      _this.setState({
        modal: modal,
        props: props,
        modalOptions: mergedOptions
      }, function () {
        return (// wrapped in timeout
          // to ensure modal comp
          // mount
          setTimeout(function () {
            // add passed / default class to body
            _this.handleBodyClass(true); // set state modalActive as true


            _this.setState({
              modalActive: true
            }, function () {
              return (// waits for the animation
                // to finish
                setTimeout(function () {
                  // if there's any passed / default
                  // onOpen func
                  if (typeof mergedOptions.onOpen === 'function') {
                    // run optional onOpen fn
                    mergedOptions.onOpen(type, props, options$$1);
                  }

                  if (typeof _this.state.onOpen === 'function') {
                    _this.state.onOpen(type, props, options$$1);
                  } // animation time comes
                  // from passed / default
                  // options

                }, mergedOptions.animationDuration)
              );
            });
          }, 50)
        );
      });
    }, _this.hideModal = function (cb) {
      if (!_this.state.modal && !_this.state.ActiveModal) {
        return;
      }

      var options$$1 = _this.state.modalOptions;

      _this.handleBodyClass(false); // sets state modalActive
      // as false (runs the close anim)


      _this.setState({
        modalActive: false
      }, function () {
        return (// wait for the animation
          // to finish
          setTimeout(function () {
            // if there's any passed / default
            // onClose func
            if (typeof options$$1.onClose === 'function') {
              // run optional onClose fn
              options$$1.onClose();
            }

            if (typeof _this.state.onClose === 'function') {
              _this.state.onClose();
            } // resets state modal and props


            _this.setState({
              modal: null,
              props: null
            }, // and then runs
            // cb if exists
            function () {
              if (typeof cb === 'function') {
                cb();
              }
            });
          }, options$$1.animationDuration)
        );
      });
    }, _this.handleBodyClass = function (add) {
      return document && document.body.classList[add ? 'add' : 'remove'](_this.state.modalOptions.onOpenClass);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ModalManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          modals = _props.modals,
          options$$1 = _props.options;

      var _ref3 = options$$1 || {},
          onClose = _ref3.onClose,
          onOpen = _ref3.onOpen;

      var mergedOptions = Object.assign({}, options, options$$1);
      this.setState({
        modals: modals,
        onClose: onClose,
        onOpen: onOpen,
        options: mergedOptions
      }); // register open and close modal events

      eventManager.on(ACTION.OPEN, function (type, props, options$$1) {
        return _this2.showModal({
          type: type,
          props: props,
          options: options$$1
        });
      }).on(ACTION.CLOSE, function (cb) {
        return _this2.hideModal(cb);
      }).emit(ACTION.DID_MOUNT, this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // unregister events
      eventManager.off(ACTION.OPEN).off(ACTION.CLOSE).emit(ACTION.WILL_UNMOUNT);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.modal) {
        return null;
      }

      var ActiveModal = this.state.modal;

      var props = _extends({}, this.state.props, {
        controller: _extends({}, this.state.modalOptions, {
          isActive: this.state.modalActive,
          onClose: this.hideModal
        })
      });

      return React.createElement(ActiveModal, props);
    }
  }]);
  return ModalManager;
}(Component);

ModalManager.propTypes = {
  modals: PropTypes.objectOf(PropTypes.func),
  options: PropTypes.object
};
var modal = {
  open: function open(type) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return eventManager.emit(ACTION.OPEN, type, props, options$$1);
  },
  close: function close(cb) {
    var options$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return eventManager.emit(ACTION.CLOSE, cb, options$$1);
  }
};
export { ModalManager, modal };